import { Stack } from "@mui/joy";
import { memo, useMemo } from "react";
import { useMediaDataRoom } from "features/mediaDataRoom/contexts";
import { MediaDataRoomVersion } from "features/mediaDataRoom/models";
import MediaDataRoomConfiguration, {
  type MediaDataRoomConfigurationProps,
} from "./components/MediaDataRoomConfiguration";

const MediaDataRoomV3ConfigurationTab = memo(() => {
  const {
    dataRoomName,
    createdAt,
    createdBy,
    matchingIdFormat,
    dataRoomId,
    participants,
    hashMatchingIdWith,
    supportedFeatures: {
      enableInsights,
      enableLookalike,
      enableRuleBasedAudiences,
      enableRemarketing,
      showAbsoluteValues,
      enableOverlapStatistics: { canView: enableOverlapStatistics },
    },
  } = useMediaDataRoom(MediaDataRoomVersion.v3);
  const configurationProps = useMemo<MediaDataRoomConfigurationProps>(() => {
    return {
      collaborationTypes: [
        ...(enableOverlapStatistics ? ["Overlap analysis"] : []),
        ...(enableInsights ? ["Insights"] : []),
        ...(enableRemarketing ? ["Remarketing audiences"] : []),
        ...(enableRuleBasedAudiences ? ["Rule-based audiences"] : []),
        ...(enableLookalike ? ["AI lookalike audiences"] : []),
      ],
      createdAt,
      createdBy,
      dataRoomId,
      dataRoomName,
      hashMatchingIdWith: hashMatchingIdWith,
      matchingIdFormat: matchingIdFormat,
      participants,
      showAbsoluteValues,
    };
  }, [
    enableInsights,
    enableLookalike,
    enableRemarketing,
    createdBy,
    participants,
    enableRuleBasedAudiences,
    createdAt,
    hashMatchingIdWith,
    matchingIdFormat,
    dataRoomName,
    dataRoomId,
    showAbsoluteValues,
    enableOverlapStatistics,
  ]);
  return (
    <Stack sx={{ gap: 2, mx: 6 }}>
      <MediaDataRoomConfiguration {...configurationProps} />
    </Stack>
  );
});
MediaDataRoomV3ConfigurationTab.displayName = "MediaDataRoomV3ConfigurationTab";

export default MediaDataRoomV3ConfigurationTab;
